module.exports = [
  "SETTINGS_VIEW_LIST",
  "SETTINGS_UPDATE"
]